/* Offre quantite — gl. Genere par bundle_kit.py, ne pas editer a la main. */
(function () {
  var LOT = document.querySelector('[data-gl-lot]');
  if (!LOT) return;

  var donnees = { options: [], variantes: [] };
  try { donnees = JSON.parse(LOT.querySelector('[data-gl-donnees]').textContent); } catch (e) {}
  var variantes = donnees.variantes || [];
  var options   = donnees.options || [];
  var devise  = LOT.getAttribute('data-devise') || '€';
  var apres   = LOT.getAttribute('data-devise-apres') === '1';
  var articles = LOT.querySelector('[data-gl-articles]');
  var alerte   = LOT.querySelector('.gl-lot__epuise');
  // Il y a plusieurs formulaires /cart/add sur la page (celui du theme, celui des
  // paiements express) : on ne choisit pas a l'avance, on part du bouton clique.

  function sous(c) {
    var v = (c / 100).toFixed(2).replace('.', ',');
    return apres ? v + ' ' + devise : devise + v;
  }
  function quantite() {
    var c = LOT.querySelector('input[name="gl-lot"]:checked');
    return c ? parseInt(c.value, 10) : 1;
  }

  // Une ligne par article, avec ses propres menus : on peut prendre deux couleurs
  // differentes, ou deux tailles. Sans option reelle, aucun menu ne s'affiche.
  function dessiner() {
    var n = quantite();
    LOT.classList.toggle('gl-lot--detaille', n > 1 && options.length > 0);
    if (!articles) return;
    var actuelles = [].map.call(articles.querySelectorAll('.gl-lot__article'), function (l) {
      return [].map.call(l.querySelectorAll('select'), function (s) { return s.value; });
    });
    articles.innerHTML = '';
    if (n < 2 || !options.length) return;
    for (var i = 0; i < n; i++) {
      var ligne = document.createElement('div');
      ligne.className = 'gl-lot__article';
      var menus = '<span class="gl-lot__menus">';
      for (var o = 0; o < options.length; o++) {
        menus += '<select data-option="' + o + '" aria-label="' + options[o].nom + '">';
        for (var v = 0; v < options[o].valeurs.length; v++) {
          var val = options[o].valeurs[v];
          var choisi = actuelles[i] && actuelles[i][o] === val ? ' selected' : '';
          menus += '<option value="' + val.replace(/"/g, '&quot;') + '"' + choisi + '>' + val + '</option>';
        }
        menus += '</select>';
      }
      menus += '</span>';
      ligne.innerHTML = '<span class="gl-lot__rang">' + LOT.getAttribute('data-mot-article') + ' ' + (i + 1) + '</span>' + menus;
      articles.appendChild(ligne);
    }
  }

  function trouver(choix) {
    for (var i = 0; i < variantes.length; i++) {
      var ok = true;
      for (var o = 0; o < choix.length; o++) if (variantes[i].options[o] !== choix[o]) { ok = false; break; }
      if (ok) return variantes[i];
    }
    return null;
  }

  function lignes(formule) {
    var n = quantite();
    if (n < 2 || !options.length) {
      var champ = formule && formule.querySelector('[name="id"]');
      var id = champ ? champ.value : (variantes[0] && variantes[0].id);
      return id ? [{ id: Number(id), quantity: n }] : [];
    }
    var sortie = [], manquant = false;
    [].forEach.call(articles.querySelectorAll('.gl-lot__article'), function (l) {
      var choix = [].map.call(l.querySelectorAll('select'), function (s) { return s.value; });
      var v = trouver(choix);
      if (!v || !v.dispo) { manquant = true; return; }
      sortie.push({ id: v.id, quantity: 1 });
    });
    if (alerte) alerte.hidden = !manquant;
    return manquant ? [] : sortie;
  }

  function majPrix() {
    var base = parseInt(LOT.getAttribute('data-prix'), 10) || 0;
    [].forEach.call(LOT.querySelectorAll('.gl-lot__choix'), function (c) {
      var n = parseInt(c.querySelector('input').value, 10);
      var r = parseInt(c.getAttribute('data-remise'), 10) || 0;
      var plein = base * n;
      var net = Math.round(plein * (100 - r) / 100);
      var p1 = c.querySelector('.gl-lot__prix');
      p1.innerHTML = (r ? '<span class="gl-lot__barre">' + sous(plein) + '</span>' : '') + sous(net);
    });
  }

  LOT.addEventListener('change', function (e) {
    if (e.target.name === 'gl-lot') { dessiner(); if (alerte) alerte.hidden = true; }
  });

  // On prend la main sur le CLIC du bouton, pas sur le submit : le tiroir panier
  // ecoute deja 'submit' sur document en capture et coupe la propagation, donc un
  // listener de formulaire ne se declenchait jamais. En arretant le clic, aucun
  // evenement submit n'est meme emis.
  {
    document.addEventListener('click', function (e) {
      var bouton = e.target && e.target.closest && e.target.closest('[type="submit"]');
      if (!bouton) return;
      var formule = bouton.closest('form[action*="/cart/add"]');
      if (!formule) return;
      var n = quantite();
      if (n < 2) return;                       // un seul article : le theme fait son travail
      e.preventDefault();
      e.stopPropagation();
      var items = lignes(formule);
      if (!items.length) return;
      bouton.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () {
        var t = window.glTiroirPanier;
        if (t) return t.rafraichir().then(t.ouvrir);
        window.location.href = '/cart';
      }).catch(function () {}).then(function () {
        bouton.removeAttribute('aria-busy');
      });
    }, true);
  }

  majPrix();
  dessiner();
})();
